namespace Matrix.Data {
    export class ClientTableColumns {
        static columnsKey = 'Data.ClientTable';
    }
}
